<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import ModuleTitle from '@/components/layout/ModuleTitle'

  export default {
    name: 'GDPRVideoModule',
    components: {
      ModuleTitle,
    },
    props: {
      options: {
        type: Object,
        default: _ => {},
      },
    },
    computed: {
      getVideoLink() {
        const hasOwnLanguage = this.options && this.options.options && this.options.options.language
        const language = hasOwnLanguage ? this.options.options.language : this.$i18n.locale
        return `/static/gdpr-training/vbt-datenschutz-${language.substring(0, 2)}/story.html`
      },
    },
  }
</script>
